import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";
import { motion } from "framer-motion";

export const Wrapper = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  // gap: ${() => `${viewSizeCalculator(0.875)}`}; // 1.25rem
  // height: ${() => `${viewSizeCalculator(3.75)}`}; // 4.5rem
  // flex: 1;
  padding: ${() =>
    `${viewSizeCalculator(0.6875)} ${viewSizeCalculator(0)} ${viewSizeCalculator(0.6875)} ${viewSizeCalculator(0)}`};

  position: relative;

  ${({ showGradient }) =>
    showGradient &&
    `
    &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: ${viewSizeCalculator(3)};
        height: 100%;
        background: linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
        // background: linear-gradient(to left, rgb(245, 97, 97), rgba(255, 255, 255, 0));
        pointer-events: none;
        transition: opacity 0.3s ease;
        opacity: 0.7;
      }
  `}
`;

export const DropdownWrapper = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.100)}`}; // 1.25rem
  // height: ${() => `${viewSizeCalculator(3.75)}`}; // 4.5rem
  // flex: 1;

  // overflow: auto;
  overflow-x: auto;
  //overflow-y: hidden;
  flex-wrap: nowrap; // Prevent line breaks
  position: relative;
  // border: 1px solid #000;

  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for Firefox */
  scrollbar-width: none;

  /* Hide scrollbar for IE and Edge */
  -ms-overflow-style: none;
`;

export const AddHospitalWrapper = styled(motion.div)`
  // width: ${() => `${viewSizeCalculator(23.5)}`}; // 19.75rem
  min-width: ${() => `${viewSizeCalculator(23.5)}`}; // 19.75rem
  height: ${() => `${viewSizeCalculator(4)}`}; // 3.75rem
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: ${() => `${viewSizeCalculator(0.925)}`};
`;